
import dust from "dustjs-linkedin";

import "template/grammar/fr/table/verb-desktop.js";
import "template/grammar/fr/table/verb-mobile.js";

(function(){dust.register("grammar/fr/table/verb",body_0);function body_0(chk,ctx){return chk.write("<header><div class=\"toggle\">").helper("svg",ctx,{},{"path":"arrow-large"}).write("</div><div class=\"title\">").helper("grammar",ctx,{},{"collection":"grammar_table","id":"verb","language":"fr","a":ctx.get(["Ver_Inf"], false)}).write("</div></header><main>").partial("grammar/fr/table/verb-desktop",ctx,{}).partial("grammar/fr/table/verb-mobile",ctx,{}).write("<article><p>* ").helper("grammar",ctx,{},{"collection":"grammar_table","id":"imperative_hint","language":"fr"}).write("</p></article></main>");}return body_0;})();

export default 0;
